import { useEffect } from 'react';
import Tooltip from '@Components/Tooltip';

export default function useHideTooltipsOnScroll(containerRef) {
  useEffect(() => {
    let isScrollingStarted = false;
    let scrollTimer;
    const onScroll = () => {
      if (!isScrollingStarted) {
        Tooltip.hide(); // hide all tooltips on scroll start
        isScrollingStarted = true;
      }
      clearTimeout(scrollTimer);

      // Set a new timer to reset the scrollingStarted flag after scrolling ends
      scrollTimer = setTimeout(() => {
        isScrollingStarted = false;
      }, 200);
    };
    if (containerRef && containerRef.current) {
      containerRef.current.addEventListener('scroll', onScroll);
    }
    return () => {
      if (containerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        containerRef.current.removeEventListener('scroll', onScroll);
      }
    };
  }, [containerRef]);
}
